<template>
	<Row>
		<slot />

		<div class="xl:container w-full xl:flex xl:gap-[80px]">
			<div class="columns w-full xl:max-w-[912px]">
				<slot name="main" />
			</div>
			<div
				class="mt-[32px] block xl:mt-0 w-full md:max-w-[380px] ml-auto mr-auto xl:mr-0 px-[16px] md:px-0"
			>
				<slot name="aside" />
			</div>
		</div>
	</Row>
</template>

<style lang="scss" scoped>
.xl\:mt-0 {
	margin-top: 32px;
}
@media (min-width: 1360px) {
	.xl\:mt-0 {
		margin-top: 0px;
	}
}
.xl\:mr-0 {
	margin-right: auto;
}

.xl\:flex {
	display: block;
}
@media (min-width: 1360px) {
	.xl\:mr-0 {
		margin-right: 0px;
	}

	.xl\:flex {
		display: flex;
	}
}
</style>
